<template>
    <van-popup v-model="visible" position="center" :overlay="true" :close-on-click-overlay="true" class="media-preview-popup" @click-overlay="$emit('input', false)">
        <div class="preview-box" @click.self="$emit('input', false)">
            <van-swipe :initial-swipe="start" :show-indicators="false" @click.self="$emit('input', false)">
                <van-swipe-item v-for="(m, i) in list" :key="i" @click.self="$emit('input', false)">
                    <div class="media-wrap" @click.self="$emit('input', false)">
                        <img v-if="isImage(m.url)" class="media-img" :src="m.url" alt="" />
                        <video v-else-if="isVideo(m.url)" class="media-video" :src="m.url" controls />
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
    </van-popup>
</template>

<script>
    import { isImage, isVideo } from '@/utils/index.js'
    export default {
        name: 'MediaPreview',
        props: {
            value: { type: Boolean, default: false },
            list: { type: Array, default: () => [] },
            startIndex: { type: Number, default: 0 },
        },
        data() {
            return { visible: this.value, start: this.startIndex };
        },
        watch: {
            value(nv) { this.visible = nv },
            visible(nv) { this.$emit('input', nv); if (!nv) this.stopAll(); },
            startIndex(nv) { this.start = nv },
        },
        methods: {
            stopAll() {
                try {
                    const videos = this.$el ? this.$el.querySelectorAll('video') : []
                    videos.forEach(v => { try { v.pause(); v.currentTime = 0; v.removeAttribute('src'); v.load(); } catch (e) { } })
                } catch (e) { }
            },
            isImage,
            isVideo,
        }
    }
</script>

<style scoped lang="less">
    .media-preview-popup {
        width: 100%;
    }

    .preview-box {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        overflow: hidden;
    }

    .media-wrap {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .media-img {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
    }

    .media-video {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
    }

    .van-popup {
        background: none !important;
    }

    .van-swipe {
        width: 100%;
        height: auto !important;
    }

    :deep(.van-swipe__track) {
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto !important;
    }

    :deep(.van-swipe__item) {
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto !important;
    }
</style>
